<template>
  <Head>
    <Title>RISER - {{ trip.title }}</Title>
    <Meta charset="utf-8" />
    <Meta name="twitter:card" content="summary_large_image" />
    <Meta name="twitter:site" content="@riserblog" />
    <Meta name="twitter:image" :content="trip.share_image_url" />
    <Meta property="og:type" content="website" />
    <Meta property="og:url" :content="url" />
    <Meta property="og:title" :content="'RISER - Trip: ' + (trip.title || '')" />
    <Meta name="og:image" :content="trip.share_image_url" />
    <Meta property="og:site_name" :content="'RISER: ' + (trip.title || '')" />
    <Meta property="og:description" :content="trip.note" />
    <Meta property="fb:app_id" content="1628040120818813" />
    <Meta name="description" :content="trip.note" />
    <link rel="canonical" :href="url" />
  </Head>
</template>

<script>
export default {
  props: {
    trip: {
      required: true
    }
  },
  computed: {
    url() {
      const config = useRuntimeConfig()
      const base = config.public.dev
        ? 'https://development--riser-app.netlify.app'
        : 'https://riserapp.com'
      const route = useRoute()
      return base + route.fullPath
    }
  }
}
</script>
